export default __webpack_public_path__ + "static/media/item_5@2x.74f1263a.webp";